import { type Margin, type Padding, type ResponsiveProperties } from '../types';

export const spacingClasses = (
  prefix: string,
  spacing: Margin | Padding | undefined,
): string[] => {
  if (!spacing) return [];

  if (typeof spacing === 'object') {
    const classes: string[] = [];
    Object.entries(spacing).forEach(([key, value]) => {
      if (!value) return;

      const directions =
        key === 'x'
          ? ['left', 'right']
          : key === 'y'
            ? ['top', 'bottom']
            : [key];
      directions.forEach((dir) => classes.push(`${prefix}-${dir}-${value}`));
    });
    return classes;
  }

  return [`${prefix}-${spacing}`];
};

export function responsiveClasses<T extends string | number | undefined>(
  property: string,
  values: ResponsiveProperties<T>,
): string[] {
  if (!values) return [];

  const classes: string[] = [];

  if (typeof values === 'string' || typeof values === 'number') {
    classes.push(`${property}-${values}`);
  } else {
    Object.entries(values).forEach(([breakpoint, value]) => {
      if (value) {
        const className = `${property}-${value}-${breakpoint}`;
        classes.push(className);
      }
    });
  }

  return classes;
}

export const joinClasses = (
  classes: string[],
  scss: {
    readonly [key: string]: string;
  },
) => {
  return classes
    .map((c) => scss[c])
    .join(' ')
    .trim();
};
